<template>
  <div class="container has-background-white">
    <slot />
  </div>
</template>

<script>
export default {
}
</script>